import { MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED } from '@shopDetails/model';
import getPropFromModule from './getPropFromModule';

const getIsMaxProductQuantityTooltipClosed = state =>
  getPropFromModule(state, MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED);

export default getIsMaxProductQuantityTooltipClosed;
